export const TOGGLE_FINANCIAL_TARGET_GRID = "FINANCIAL_TARGET/TOOGLE_GRID";
export const UPDATE_SELECTED_TARGET_IDS = "FINANCIAL_TARGET/UPDATE_SELECTED_TARGET_IDS";
export const UPDATE_DISPLAYED_ROWS = "FINANCIAL_TARGET/UPDATE_DISPLAYED_ROWS";
export const UPDATE_COLLAPSE_MODE = "FINANCIAL_TARGET/UPDATE_COLLAPSE_MODE";
